import React from "react";
import { Route, Redirect } from "react-router-dom";
import useUser from "./hooks/useUser";

const UserAccountRoute = ({ children, ...rest }) => {
  const user = useUser();
  return (
    <Route
      {...rest}
      render={({ location }) =>
        user.email ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/account",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};
export default UserAccountRoute;
